export default "__VITE_ASSET__Bx0sMu5E__"